import { render, staticRenderFns } from "./activityLog.vue?vue&type=template&id=494a3c4a&scoped=true&"
import script from "./activityLog.vue?vue&type=script&lang=js&"
export * from "./activityLog.vue?vue&type=script&lang=js&"
import style0 from "./activityLog.vue?vue&type=style&index=0&id=494a3c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494a3c4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('494a3c4a')) {
      api.createRecord('494a3c4a', component.options)
    } else {
      api.reload('494a3c4a', component.options)
    }
    module.hot.accept("./activityLog.vue?vue&type=template&id=494a3c4a&scoped=true&", function () {
      api.rerender('494a3c4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/workspace/activityLog.vue"
export default component.exports